import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Se stiamo tornando dal callback OAuth (session_id nel fragment), non fare
    // il check /auth/me: sarà AuthCallback a scambiare la sessione e impostare il token.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const token = localStorage.getItem("enoteca_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("enoteca_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("enoteca_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    localStorage.setItem("enoteca_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, address = "", newsletter = false, visitor_id = "") => {
    const { data } = await api.post("/auth/register", { name, email, password, address, newsletter, visitor_id });
    localStorage.setItem("enoteca_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerCompany = async (payload) => {
    const { data } = await api.post("/aziende/register", payload);
    localStorage.setItem("enoteca_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("enoteca_token");
    setUser(null);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem("enoteca_token");
    if (!token) return null;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      return null;
    }
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithGoogleSession, register, registerCompany, logout, refreshUser, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
